<template>
  <router-view />
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),

  methods: {
    async update() {
      await this.$workbox.messageSW({ type: "SKIP_WAITING" });
    }
  },

  created() {
    if (this.$workbox) {
      this.$workbox.addEventListener("waiting", () => {
        this.update();

        this.$buefy.loading.open();
        this.$buefy.toast.open({
          message: "Memperbaharui aplikasi..."
        });
      });
    }
  }
};
</script>

<style lang="scss">
body {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
}

body,
button,
input,
select,
textarea {
  font-family: Roboto, serif !important;
}

.table-wrapper {
  overflow: visible !important;
}

.table-wrapper .loading-overlay {
  z-index: 8;
}

.table .c-action-column {
  white-space: nowrap;
  text-align: right;
}

#app:not(.is-mobile) .table .c-action-column .button {
  opacity: 0.5;
}

#app .table tr:hover .c-action-column .button {
  opacity: 1;
}

.table .c-action-column .button:not(:last-child),
.table .c-action-column .b-tooltip:not(:last-child) {
  margin-right: 4px;
}

.table .c-action-column .button.is-small {
  margin-top: -3px;
  margin-bottom: -3px;
}
.table .c-image-column .button:not(:last-child),
.table .c-image-column .b-tooltip:not(:last-child) {
  margin-right: 4px;
}

.table .c-image-column .button.is-small {
  height: 34px !important;
  padding-right: 4px;
  padding-left: 4px;
  margin-top: -5px;
  margin-bottom: -5px;
}

@media screen and (max-width: 768px) {
  .button.is-hidden-label-mobile .icon:first-child:not(:last-child) {
    margin-right: calc(-0.5em - 1px);
  }

  .button.is-hidden-label-mobile span:last-child:not(.first-child) {
    display: none !important;
  }
}

.c-container {
  flex-grow: 1;
  margin: 0 auto 0.5rem auto;
  position: relative;
  width: auto;
}

@media screen and (min-width: 1024px) {
  .c-container {
    max-width: 960px !important;
  }
}

.dropdown-item:empty {
  display: none !important;
}

.c-tabs-full .tabs {
  margin-bottom: 0.5rem !important;
}

.c-tabs-nav-hide .tabs {
  display: none;
}

.c-tabs-full .tab-content {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}

.c-tabs-nav-hide .tab-content {
  padding: 0 !important;
}

.c-has-border-bottom {
  border-bottom: 1px solid $grey-lightest;
}


</style>
